export default "__VITE_ASSET__CgHwyV7B__"